import React from 'react'
import PropTypes from "prop-types";
import {setupOnExtractData} from "../../../util/FormUtil";

export const PROP_NAME_PRIVACY_POLICY = "privacyPolicy";
export const PROP_NAME_TERMS_OF_USE = "termsOfUse";
export const PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL = "marketingCommunicationsApproval";

class PolicyAgreementInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.checkBoxChange = this.checkBoxChange.bind(this);
        this.marketingApprovalChange =  this.marketingApprovalChange.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    extractData(){
        const {data} = this.props;
        const result = {};
        result[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL] = data[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL];
        result[PROP_NAME_PRIVACY_POLICY] = data[PROP_NAME_PRIVACY_POLICY];
        result[PROP_NAME_TERMS_OF_USE] = data[PROP_NAME_TERMS_OF_USE];
        return result;
    }

    componentDidMount() {
        const {setFormState, metadata, data} = this.props;

        //Init to yes
        if(!metadata[PROP_NAME_PRIVACY_POLICY]) {
            setFormState({property: PROP_NAME_PRIVACY_POLICY, data: data[PROP_NAME_PRIVACY_POLICY] ? data[PROP_NAME_PRIVACY_POLICY] : false, metadata: {dirty: false, valid: data[PROP_NAME_PRIVACY_POLICY] ? true: false}});
        }
        if(!metadata[PROP_NAME_TERMS_OF_USE]) {
            setFormState({property: PROP_NAME_TERMS_OF_USE, data: data[PROP_NAME_TERMS_OF_USE] ? data[PROP_NAME_TERMS_OF_USE] : false, metadata: {dirty: false, valid: data[PROP_NAME_TERMS_OF_USE] ? true: false}});
        }
        if(!metadata[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL]) {
            setFormState({property: PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL, data: data[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL] ? data[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL] : false, metadata: {dirty: false, valid: true}});
        }

        setupOnExtractData(this);
    }

    checkBoxChange(e){
        const {setFormState} = this.props;
        setFormState(
            {property: e.target.id, data: e.target.checked, metadata: {dirty: true, valid: e.target.checked}}
        );
    }

    marketingApprovalChange(e){
        const {setFormState} = this.props;
        setFormState(
            {property: e.target.id, data: e.target.checked}
        );
    }

    render() {
        // for My Profile - policies are read only and hard-coded as selected
        const {data, isEditable = true, policiesReadOnly, userDataInit, hideMarketingCommunicationsApproval} = this.props;
        return (
            <div className={"grid"}>
                <div className="grid__col-sm-8">
                    <ul className={"form-fields check-list--medium"}>
                        <li>
                            <input type={"checkbox"}
                                   id={PROP_NAME_PRIVACY_POLICY}
                                   checked={data[PROP_NAME_PRIVACY_POLICY] || policiesReadOnly}
                                   onChange={this.checkBoxChange}
                                   disabled={ policiesReadOnly || !isEditable ? "disabled" : null}
                            />
                            <label
                                style={{textTransform:'inherit'}}
                                htmlFor={PROP_NAME_PRIVACY_POLICY}
                            >
                                I have read and understand the <a href="http://www.cmegroup.com/privacy-policy.html" target="_blank">CME Group Privacy Notice</a>
                            </label>
                        </li>
                        <li>
                            <input type={"checkbox"}
                                   id={PROP_NAME_TERMS_OF_USE}
                                   checked={data[PROP_NAME_TERMS_OF_USE] || policiesReadOnly}
                                   onChange={this.checkBoxChange}
                                   disabled={ policiesReadOnly || !isEditable ? "disabled" : null}
                            />
                            <label
                                style={{textTransform:'inherit'}}
                                htmlFor={PROP_NAME_TERMS_OF_USE}
                            >
                                I have read and agree to the <a href="https://www.cmegroup.com/files/terms-of-use.pdf" target="_blank">Terms of Use</a> and <a href="http://www.cmegroup.com/cookie-policy.html" target="_blank">Cookie Notice</a>
                            </label>
                        </li>
                        {
                            !hideMarketingCommunicationsApproval &&
                            <li>
                                <input type={"checkbox"}
                                       id={PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL}
                                       checked={data[PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL]}
                                       onChange={this.marketingApprovalChange}
                                       disabled={!isEditable ? "disabled" : null}
                                />
                                <label
                                    style={{textTransform: 'inherit', marginLeft: '16px', marginTop: '-18px'}}
                                    htmlFor={PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL}
                                >
                                    Yes. By checking this box, I agree to receive communications regarding CME Group products, services,
                                    and events that are of interest to me. I understand that I can unsubscribe at any time.
                                    By registering, I confirm that I have read and fully understand the  <a
                                    href="http://www.cmegroup.com/privacy-policy.html" target="_blank">CME Group Privacy
                                    Notice</a>. (optional) </label>
                            </li>
                        }
                    </ul>
                </div>
                <div className="grid__col-sm-4 no-padding-bottom">
                </div>
            </div>
        );
    }
}

PolicyAgreementInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,
    isEditable: PropTypes.bool,
    hideMarketingCommunicationsApproval: PropTypes.bool,
    userDataInit: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    metadata: PropTypes.object.metadata,    // TODO isRequired ?
    onExtractData: PropTypes.func,
    policiesReadOnly: PropTypes.object
};

export default PolicyAgreementInputComponent;

